module.exports = __webpack_public_path__ + "static/media/arrow-left.3e2210e3.svg";